<div class="uploader">
  <uppy-dashboard [uppy]="uppy" [props]="uppyDashboardOptions"></uppy-dashboard>
</div>
